// 多鏡頭事件 / 錄影的鏡頭小膠囊（plan SPEC #multi-lens-playback：列表與詳情設備名後加「下鏡頭」，主鏡頭不標）。
import { useTranslation } from 'react-i18next';
import type { VmsDevice } from '../lib/devices';
import { lensName, useLensDecl } from '../lib/lens';

export function LensChip({ cam, lens }: { cam?: VmsDevice | null; lens: number }) {
  const { t } = useTranslation();
  const decl = useLensDecl(cam);
  if (!lens) return null;
  const name = lensName(t, decl, lens);
  return (
    <span className="badge lens-chip" data-lens={lens} aria-label={t('events.lens_chip_a11y', { name })} style={{ marginLeft: 6 }}>
      {name}
    </span>
  );
}
